import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import './QuizDetailsModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { LuClock3 } from "react-icons/lu";
import xImg from './x.png';
import { GrCircleQuestion } from "react-icons/gr";
import styles from './QuizDetailsModal.module.css';
import { convertToBengaliNumber } from './helper';
import QuizRewards from './QuizRewards';
import QuizWinnerList from './QuizWinnerList';
import { useNavigate } from 'react-router-dom';
import { fetchSubscriptionUrlByEventId } from '../../../services';
import { Spinner } from 'react-bootstrap';
const QuizDetailsModal = ({ showQuizDetailsModal, setShowQuizDetailsModal, activeQuizBannerId }) => {
  const navigate = useNavigate();
  const { events,playerData,token } = useContext(dataContext);
  const [isLoading, setIsLoading] = useState(false);


  function hideModalOperation() {
    setShowQuizDetailsModal(false)
  }

  useEffect(() => {
    activityLogSubmission("QuizDetailsModal");
    analyticEvent('QuizDetailsModal', 'QuizDetailsModal-view')
  }, [])

  let event = events.find(event => event.id === activeQuizBannerId);
  let showKhelunButton = false;
  let showTrialButton = false;
  let showSubscribeButton = false;

  if(event?.id === 34) {
    if(playerData?.isSubscribe) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
      if(playerData?.is_trial_played === false) {
        showTrialButton = true;
      }
    }
  }else if(event?.id === 149) {
    if(playerData?.isSubscribeBcs) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
      if(playerData?.is_trial_played === false) {
        showTrialButton = true;
      }
    }
  }
  else if(event?.id === 75) {
    if(playerData?.isSubscribeSports) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
      if(playerData?.is_trial_played === false) {
        showTrialButton = true;
      }
    }
  }
  else{
    if(playerData?.isSubscribeTournament) {
      showKhelunButton = true;
    }else{
      showSubscribeButton = true;
      if(playerData?.is_trial_played === false) {
        showTrialButton = true;
      }
    }
  }

  function handleSubscribeButtonClick() {
    setIsLoading(true);
    fetchSubscriptionUrlByEventId(token, event?.id).then(res => {
      window.location.replace(`${res?.redirectURL}`);
      setIsLoading(false);
      setShowQuizDetailsModal(false);
    });
  }
  return (
    <>{event &&
      <Modal show={showQuizDetailsModal} centered dialogClassName="modal-dialog" backdrop="static" contentClassName="modalContentQuizDetailsModal" onHide={hideModalOperation}>
        {/* <Modal.Header closeButton >
        </Modal.Header> */}
        <Modal.Body style={{ maxHeight: "65vh", overflow: "scroll", display: 'block', overflowX: 'hidden', padding: '12px 12px 24px',borderRadius: '32px',backgroundColor: '#f5f5f5' }}>
        <img src={xImg} alt="logo" className={styles.xImg} onClick={hideModalOperation} />
            <div className={styles.quizCard}>
              <img
                src={event?.banner_url}
                alt={event?.events}
                className={styles.bannerImage}
              />
              <div className={styles.quizInfo}>
                <h3 className={styles.quizTitle}>{event?.events}</h3>
                {/* <div className={styles.quizMeta}> */}
                  <div className={styles.metaItem}>
                    <LuClock3 className={styles.icon} />
                    <span> খেলার সময়: {convertToBengaliNumber(event.allocated_time)} সে.</span>
                  </div>
                  <div className={styles.metaItem}>
                    <GrCircleQuestion className={styles.icon} />
                    <span>প্রশ্ন: {convertToBengaliNumber(event?.question_set)}টি</span>
                  </div>
                {/* </div> */}
              </div>
                  {showKhelunButton && <button
                    className={styles.playButton}
                    onClick={()=>{navigate(`/quiz/?eventId=${event?.id}`, { replace: true });}}
                  >
                    খেলুন →
                  </button>}
                  {showSubscribeButton && <button
                    className={styles.playButton}
                    onClick={handleSubscribeButtonClick}
                  >
                    {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "সাবস্ক্রাইব করে খেলুন"}
                  </button>}
                  {showTrialButton && <button
                    className={`${styles.playButton} ${styles.trialButton}`}
                    onClick={()=>{navigate(`/quiz/?eventId=145`, { replace: true });
                    sessionStorage.setItem('trial_eventId', event?.id);}}
                  >
                    ফ্রি ট্রাই করুন
                  </button>}
                  
              <QuizRewards event={event} />
              <QuizWinnerList eventId={event?.id} />
            </div>
          
        </Modal.Body>
      </Modal>}
    </>
  )
}

export default QuizDetailsModal